// Copyright (c) 2016 Deere & Company

const checkCustomerRefusalValidity = pipCodeObject => {

    const stringsCollection = [
        pipCodeObject.workOrderNumber,
        pipCodeObject.reasonForRefusal,
        pipCodeObject.witness.firstName,
        pipCodeObject.witness.lastName
    ];

    return (
        stringsCollection.every(elem => elem !== '') && pipCodeObject.refusedDate !== null
    );

};

const checkNoResponseValidity = pipCodeObject =>
    pipCodeObject.postalTrackingNumber !== '' && pipCodeObject.postalDeliveryDate !== null;

export const areFieldsValid = pipCodeObject => {

    if (!pipCodeObject.pipCodeType.key) {

        return false;

    }

    const pipCodeTypes = {
        '01': checkCustomerRefusalValidity,
        '02': checkNoResponseValidity
    };

    const validatorType = pipCodeTypes[pipCodeObject.pipCodeType.key];

    return validatorType(pipCodeObject);

};




// WEBPACK FOOTER //
// ./src/pip/pip-code/form-field-validators/verify-required-fields.js